module.exports = __webpack_public_path__ + "img/avatar2.fc9d753f.png";